(function ($) {

    var SELECTOR = ':input[data-toggle="disabled"]'

    var $body = $('body');

    var InputToggleDisabled = {};

    InputToggleDisabled.changeInputToggleDisabled = function (event) {
        var $input = $(this);

        if (!$input.is('input[type="checkbox"]')) {
            return;
        }

        var $target = $($input.attr('data-target'));
        $target.prop('disabled', $input.prop('checked') ? false : true);
    }

    InputToggleDisabled.refreshInputToggleDisabled = function (event) {
        $(this).trigger('change.input-toggle-disabled');
    }

    $(document).ready(function () {
        $body.on('change.input-toggle-disabled', SELECTOR, InputToggleDisabled.changeInputToggleDisabled);
        $body.on('refresh.input-toggle-disabled', SELECTOR, InputToggleDisabled.refreshInputToggleDisabled);
        $body.find(SELECTOR).trigger('refresh.input-toggle-disabled');
    });

})(require('jquery'));
